/// <reference path="../../../../Scripts/typings/breeze/breeze.d.ts" />
/// <reference path="../../../../Scripts/typings/q/q.d.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/navigationmanager/services/navigationrepository',["require", "exports", "models/breeze", "services/settings", "services/httpclient"], function (require, exports, Data, Configuration, Http) {
    "use strict";
    var NavigationRepository = (function (_super) {
        __extends(NavigationRepository, _super);
        function NavigationRepository() {
            var serviceUrl = Configuration.Settings.getApiFor("/breeze/navigation");
            _super.call(this, serviceUrl);
        }
        NavigationRepository.prototype.onMetadataRequested = function (store) {
            this.addNavigationType(store);
        };
        NavigationRepository.prototype.updateAsync = function (source) {
            var service = new Http.Channel();
            var data = source;
            return service.putDataAsync("/api/navigation", Http.ServiceTarget.portalApi, data);
        };
        NavigationRepository.prototype.updateModuleLocksAsync = function (memberId, source) {
            var service = new Http.Channel();
            var data = [];
            source().forEach(function (m) { return data.push(m); });
            return service.putDataAsync("/api/networkmember/{memberId}/locks".replace("{memberId}", memberId), Http.ServiceTarget.portalApi, data);
        };
        NavigationRepository.prototype.addNavigationType = function (store) {
            var type = new breeze.ComplexType();
            type.shortName = "Navigation";
            type.namespace = "AIP.API.Configuration.Model";
            type.addProperty(new breeze.DataProperty({ nameOnServer: "Id", dataType: breeze.DataType.Guid, isNullable: false, isPartOfKey: true }));
            type.addProperty(new breeze.DataProperty({ nameOnServer: "MemberType", dataType: breeze.DataType.String, isNullable: true }));
            type.addProperty(new breeze.DataProperty({ nameOnServer: "OrganizationId", dataType: breeze.DataType.Guid, isNullable: true }));
            type.addProperty(new breeze.DataProperty({ nameOnServer: "NetworkMemberId", dataType: breeze.DataType.Guid, isNullable: true }));
            type.addProperty(new breeze.DataProperty({ nameOnServer: "Tree", dataType: breeze.DataType.Undefined, isNullable: true }));
            store.addEntityType(type);
        };
        return NavigationRepository;
    }(Data.BreezeRepository));
    exports.NavigationRepository = NavigationRepository;
});

